<template>
  <img :src="googleMapsSrc" class="pd-VendorSide_GoogleStaticMap" border="0" />
</template>

<script>
export default {
  name: "GoogleMapStatic",
  props: {
    apikey: {
      required: true,
      type: String,
    },
    zoomlevel: {
      required: true,
      type: String,
    },
    lat: {
      required: true,
      type: String,
    },
    lng: {
      required: true,
      type: String,
    },
    mapstyle: {
      type: String,
      default: "",
    },
    markerPath: {
      type: String,
      required: true,
    },
    cropToWidth: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      googleMapsBase: "https://maps.googleapis.com/maps/api/staticmap",
      mapType: "maptype=roadmap",
      size: null,
    };
  },
  computed: {
    center() {
      return `center=${this.lat},${this.lng}`;
    },
    zoom() {
      return `zoom=${this.zoomlevel}`;
    },
    scale() {
      return `scale=2`;
    },
    marker() {
      return `markers=scale:2|icon:${this.markerPath}|${this.lat},${this.lng}`;
    },
    key() {
      return `key=${this.apikey}`;
    },
    queryParameters() {
      return [
        this.center,
        this.marker,
        this.zoom,
        this.size,
        this.scale,
        this.mapType,
        this.mapstyle,
        this.key,
      ].join("&");
    },
    googleMapsSrc() {
      return [this.googleMapsBase, this.queryParameters].join("?");
    },
  },
  mounted() {
    window.addEventListener("resize", this.setMapSize);
    this.setMapSize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setMapSize);
  },
  methods: {
    setMapSize /* istanbul ignore next */() {
      this.size = `size=${this.$el.parentElement.clientWidth}x${Math.round(
        this.cropToWidth
          ? this.$el.parentElement.clientWidth / 2
          : this.$el.parentElement.clientHeight
      )}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.pd-VendorSide_GoogleStaticMap {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
